function flatten(object, path = null, separator = ".") {
  return Object.keys(object).reduce((acc, key) => {
    const value = object[key];
    const newPath = [
      path,
      key
    ].filter(Boolean).join(separator);
    const isObject = [
      typeof value === "object",
      value !== null,
      !(Array.isArray(value) && value.length === 0)
    ].every(Boolean);
    return isObject ? {
      ...acc,
      ...flatten(value, newPath, separator)
    } : {
      ...acc,
      [newPath]: value
    };
  }, {});
}
function flattenMongoQuery(obj, _current, _res = {}) {
  for (const key in obj) {
    const value = obj[key];
    const newKey = _current ? _current + "." + key : key;
    if (value && typeof value === "object" && !Array.isArray(value) && !Object.keys(value).find((item) => item.startsWith("$")))
      flattenMongoQuery(value, newKey, _res);
    else
      _res[newKey] = value;
  }
  return _res;
}
function unflatten(obj) {
  const result = {};
  for (const key in obj) {
    const parts = key.split(".");
    let current = result;
    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];
      if (i === parts.length - 1)
        current[part] = obj[key];
      else {
        current[part] = current[part] || {};
        current = current[part];
      }
    }
  }
  return result;
}
export {
  flatten,
  flattenMongoQuery,
  unflatten
};
